const STORAGE_KEY = 'smtp_configs';

// TODO: replace localStorage calls with backend API endpoints when ready

const SmtpConfigService = {
  getConfigs() {
    // TODO: GET /api/email/smtp/configs
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  },

  saveConfig(config) {
    // TODO: POST /api/email/smtp/configs
    const configs = this.getConfigs();
    const newConfig = {
      ...config,
      id: `smtp-${Date.now()}`,
      savedAt: new Date().toISOString(),
    };
    configs.push(newConfig);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(configs));
    return newConfig;
  },

  deleteConfig(id) {
    // TODO: DELETE /api/email/smtp/configs/:id
    const configs = this.getConfigs().filter((c) => c.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(configs));
  },
};

export default SmtpConfigService;
